import PropTypes from "prop-types";

// Example data: array of numbers (activity levels)
const defaultData = [4, 2, 5, 3, 6, 2, 4, 5, 3, 4];
const defaultDays = Array.from({ length: 10 }, () => null); // fallback if no days provided

const BAR_COLORS = [
  "#434DFF", // primary
  "rgba(67, 77, 255, 0.3)", // primary opacity 30%
];

const BarChartActivity = ({ data = defaultData, days = defaultDays }) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-end h-32 w-full gap-3 p-4">
        {data.map((value, idx) => {
          const hasNote = value > 0;
          const color = hasNote ? BAR_COLORS[0] : BAR_COLORS[1];
          const height = "100%";
          return (
            <div
              key={idx}
              className="flex-1 flex flex-col items-center justify-end"
              style={{ height: "100%" }}
            >
              <div
                className="w-full max-w-4 rounded-full transition-all"
                style={{
                  height,
                  background: color,
                  borderRadius: "999px",
                  transition: "height 0.3s",
                }}
              />
            </div>
          );
        })}
      </div>
      {/* Days of week labels */}
      <div className="flex w-full gap-3 px-4 mt-1">
        {days.map((day, idx) => (
          <div key={idx} className="flex-1 flex flex-col items-center">
            <span
              className={
                day && day.isSame && day.isSame(new Date(), "day")
                  ? "text-primary border border-[color:var(--color-primary)] rounded-full px-1.5 py-1 self-center !rounded-full w-8 h-8 flex items-center justify-center"
                  : "rounded-full px-2 py-1 !rounded-full w-7 h-7 flex items-center justify-center"
              }
              style={{ fontSize: "0.8rem" }}
            >
              {day ? day.format("dd") : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

BarChartActivity.propTypes = {
  data: PropTypes.array.isRequired,
  days: PropTypes.array.isRequired,
};

export default BarChartActivity;
